import { isNullish } from 'remeda';

export const getPreview = (body: string | null): string => {
  if (isNullish(body)) return '';
  return body
    .replace(/<[^>]+>/g, ' ')
    .replace(/\s+/g, ' ')
    .trim()
    .slice(0, 160);
};

export const getExtension = (filename: string): string => {
  const dot = filename.lastIndexOf('.');
  return dot === -1 ? 'FILE' : filename.slice(dot + 1).slice(0, 4);
};

export const downloadFromUrl = async (url: string, filename: string): Promise<void> => {
  const response = await fetch(url);
  if (!response.ok) throw new Error(`HTTP ${response.status}`);
  const blob = await response.blob();
  const blobUrl = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = blobUrl;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(blobUrl);
};
